import React, { useMemo, useState, useRef } from 'react'
import { Wrapper, TextDetail, Panel, TextAreaIcon, SelectFieldIcon, TextFieldIcon } from '../_components'
import Axios from 'axios'
import moment from 'moment'
import avatar from '../_images/avatar.png'
import { Formik } from 'formik'

export default function () {
    const [ comments, setComments ] = useState( [] )

    const [ loading, setLoading ] = React.useState( true )
    const [ record, setRecord ] = useState( null )
    const [htmlContent, setHtmlContent] = useState('');
    const [ files, setFiles ] = useState( [] )
    const ref = useRef(null);

    React.useEffect( () => {
        if( loading ) {
            fetchApplication()
        }
    },[ loading ])

    const fetchApplication = async () => {
        try {
            const response =  await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication/${localStorage.getItem( "applicationId" )}` )

            if( response.data ) {
                setRecord( response.data.record )
                setLoading( false )
            }
        } catch (error) {
            setLoading( false )
        }
    }

    const previewFile = async (e) => {
        let file_id = e.target.id
        
        try {
            const email = btoa(localStorage.getItem( "email" )); // Base64 encode
            const url = process.env.REACT_APP_API_URL+`/api/auth/get_file_details/${file_id}/${email}`
            const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        } catch (error) {}
    }

    const handleOverToGTBank  = async ( values ) => {
        console.log("waiting for UGHub response")
        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/handover_to_gt_bank`, {
                //id: record?.id,
                gtp_Currency: values.currency_codes_options,
                //gtp_OrderId: record?.id,
                gtp_CustomerCode: "NITA.2310",
                gtp_Amount: values.certification_fees_to_pay,
                gtp_PayerName: record?.created_by,
                gtp_TransDetails: record?.trading_name+" | NITA"
            } )

            if( response.data ) {
                //alert( response.data )
                console.log(response.data)
                console.log("that above is the response  data")
                //await localStorage.setItem( "link", "finance" )
                //return window.location.reload()

                const url = response.data.secureURL;
                const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                if (newWindow) newWindow.opener = null
                // setHtmlContent(sanitizeHtml(url));
            } else{
                alert("Could not redirect for payment. Contact NITA-U")
            }
        } catch (error) {
            console.log("Oops, something went wrong.contact NITA-U")
            console.log(error)
        }
    }

    const handleOverToMobileMoneyForGTBank  = async ( values ) => {
        console.log("waiting for UGHub response")
        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/handover_to_mobile_money_for_gt_bank`, {
                MSISDN: "0700155098",
                Amount: values.certification_fees_to_pay,
                Remarks: record?.trading_name+" | NITA",
                OtherInfo: "2240000750315"
            } )

            if( response.data ) {
                //alert( response.data )
                console.log(response.data)
                console.log("that above is the response  data")
                //await localStorage.setItem( "link", "finance" )
                //return window.location.reload()
            } else{
                console.log(response)
                alert("Could not get data for payment. Contact NITA-U")
            }
        } catch (error) {
            console.log("Oops, something went wrong.contact NITA-U")
            console.log(error)
        }
    }

    // Sanitize HTML content
    const sanitizeHtml = (html) => {
        // Implement your HTML sanitization logic here
        // You can use a library like DOMPurify for sanitization
        // Example: return DOMPurify.sanitize(html);

        // For simplicity, returning the HTML without sanitization
        return html;
    };

    return (
        <Wrapper>
            {loading ? (
                <div className="flex items-center justify h-full w-full">
                    {`Loading...`}
                </div>
            )
            :(<div className="bg-gray-100 h-full overflow-y-scroll grid gap-3 px-10 py-3">
            
            <div className="h-full bg-white rounded-sm grid">
                <div className="border-b border-gray-300 flex flex-row">
                    <div className="flex flex-row items-center px-2">
                        {/* <button className="text-sm underline text-red-500" onClick={() => alert("back")}>Back</button> */}
                        <h2 className="p-5 text-sm font-bold uppercase">
                        {`Complete Payment Online`}
                        </h2> <div className="text-blue-600 font-extrabold pb-1">{record?.trading_name}</div>
                    </div>
                <div />
                </div>

                <h3><TextDetail label="Payment Status" val={record?.prn_status || "NOT CLEARED"} /></h3>

                <div className="w-full">                
                    <Panel label="Application Particulars">
                        <div className="grid grid-cols-2 gap-2 items-center">
                                {record?.category === "Individual" && [
                                    { label: "Category", value: record?.category, name: "category" },
                                    { label: "Given Name/ First Name", value: record?.given_name, name: "given_name" },
                                    { label: "Surname", value: record?.surname, name: "surname" },
                                    { label: "Other Name", value: record?.middle_name, name: "other_name" },
                                    { label: "Nationality", value: record?.nationality, name: "nationality" },
                                    { label: record?.nationality === "Ugandan" ? "National ID" : "Passport No.", value: record?.nationality === "Ugandan" ? record?.national_id : record?.passport_number, name: "national_id" },
                                    { label: "Taxpayer Identification Number", value: record?.tin, name: "tin" }
                                ].map( val => {
                                    return (
                                    <TextDetail label={val.label} val={val.value} key={val.value}/>
                                    )
                                } )}

                                {record?.category === "Company" && [
                                    { label: "Certification Level", value: record?.certification_level, name: "certification_level" },
                                    { label: "Contact First Name", value: record?.contact_first_name, name: "contact_first_name" },
                                    { label: "Contact Last Name", value: record?.contact_last_name, name: "contact_last_name" },
                                    { label: "Other Name", value: record?.contact_middle_name, name: "contact_middle_name" },
                                    { label: "TIN", value: record?.tin, name: "tin" },
                                ].map( val => {
                                    return (
                                    <TextDetail label={val.label} val={val.value} key={val.value} />
                                    )
                                } )}
                            </div>

                            <div className="grid grid-cols-2 gap-2 items-center">
                            {[
                                { label: "Date of Incorporation", value: record?.doc, name: "doc" },
                                { label: "Name of Entity", value: record?.entity_name, name: "entity_name" },
                                { label: "Entity Registration", value: record?.entity_registration, name: "entity_registration" },
                                { label: "Entity Type", value: record?.entity_type, name: "entity_type" },
                                { label: "BRN", value: record?.ern, name: "ern" },
                                { label: "Membership", value: record?.membership, name: "membership" },
                                { label: "Service Type", value: record?.service_type, name: "service_type" },
                                { label: "Business Trading Name", value: record?.trading_name, name: "trading_name" },
                                { label: "Website", value: record?.website, name: "website" },
                                { label: "Annual Turnover / Income", value: record?.annual_turnover, name: "annual_turnover" },
                            ].map( val => {
                                return (
                                    <TextDetail label={val.label} val={val.value} key={val.value} />
                                )
                            } )}
                        </div> 
                    </Panel>

                    <Panel label="Complete Payment">
                        <div className="flex flex-col items-start justify-center px-5 py-2">
                            <Formik initialValues={{
                                currency_codes_options: record?.currency_codes_options,
                                certification_fees_to_pay: record?.certification_fees_to_pay,
                                actioned_by: localStorage.getItem( "username" )
                                }} onSubmit={handleOverToMobileMoneyForGTBank}>
                                { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                                    return (
                                        <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                                            <div className="w-full grid grid-rows-2 gap-1">
                                                <SelectFieldIcon 
                                                    name="currency_codes_options"
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    value={values.currency_codes_options}
                                                    label="Payment Option"
                                                    required={true}
                                                    disabled={comments[ 0 ]?.currency_codes_options ? true : false}
                                                    options={[ 
                                                        { id: 1, value: "UGX", label: "UGX" },
                                                        { id: 2, value: "USD", label: "USD" }
                                                    ]}
                                                    question="Select Currency Code" 
                                                />

                                                
                                                <TextFieldIcon 
                                                    type="text"
                                                    name="certification_fees_to_pay"
                                                    value={values.certification_fees_to_pay}
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    label="Amount to Pay"
                                                    readonly={true}
                                                    question={`Amount to Pay`}
                                                    required={true} 
                                                />
                                            </div>

                                            { ( record?.prn_status !== "C" ) && 
                                            ( <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                                {`Make Payment`}
                                            </button> ) }
                                        </form>
                                    )
                                }  }
                            </Formik>

                            {/* <div>
                                <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                            </div> */}
                        </div>
                    </Panel>
                </div>
            </div>
            </div> ) }
        </Wrapper>
    )
}

